import React, { useState } from "react";

function SuccessMessage() {
  return (
    <div className="w-full text-center">
      <p className="text-2xl font-bold mb-4">
        Messaggio inviato correttamente!
      </p>
      <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
        Torna all'inizio
      </button>
    </div>
  );
}

function Contact() {
  const [success, setSuccess] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "c15e2dd7-9f5f-4a67-8e42-9444871604f4");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      setSuccess(true);
    }
  };

  return (
    <div
      name="contact"
      className="w-full h-screen bg-[#F3DFBF] flex justify-center items-center p-4"
    >
      <div className="mt-96 flex flex-col max-w-[1000px] w-full sm:w-full">
        {success ? (
          <SuccessMessage />
        ) : (
          <>
            <div className="pb-8">
              <p className="text-4xl font-bold inline-block border-b-4 border-[#008148] text-[#008148] ">
                Contact
              </p>
              <p className="py-4 text-xl">
                Compila e invia il form per metterti in contatto con me
              </p>
            </div>

            <form onSubmit={onSubmit}>
              <div class="flex flex-col items-center gap-2 text-center ">
                <div className="relative z-0 w-96 mb-6">
                  <input
                    type="text"
                    name="name"
                    id="floating_first_name"
                    class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-black dark:border-gray-600 dark:focus:border-[#000] focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    required
                  />
                  <label
                    for="floating_first_name"
                    class="peer-focus:font-medium absolute text-sm text-black duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#000] peer-focus:dark:text-[#000] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Nome
                  </label>
                </div>
                <div class="relative z-0 w-96 mb-6 group">
                  <input
                    type="email"
                    name="email"
                    id="floating_email"
                    class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-black dark:border-gray-600 dark:focus:border-[#000] focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    required
                  />
                  <label
                    for="floating_email"
                    class="peer-focus:font-medium absolute text-sm text-black duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-[#000] peer-focus:dark:text-[#000] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Email
                  </label>
                </div>
                <div class="grid grid-cols-1">
                  <div class="relative z-0 w-96 mb-3 group">
                    <textarea
                      name="message"
                      id="message"
                      rows="6"
                      class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-[#353535] dark:border-gray-600 placeholder-white-300 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                      placeholder="Scrivi un messaggio"
                      required
                    ></textarea>
                  </div>
                </div>
                <div class="flex justify-center">
                  <button
                    type="submit"
                    class="group relative h-12 w-32 overflow-hidden rounded-lg bg-white text-lg shadow"
                  >
                    <div class="absolute inset-0 w-3 bg-[#f4a261] transition-all duration-[250ms] ease-out group-hover:w-full"></div>
                    <span class="relative text-black group-hover:text-black">
                      Invia
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default Contact;
